class ParticipantRegistration {
    constructor() {
        const form = document.getElementById('participant-registration');
        if (!form) {
            return;
        }
        const requiredFields = form.querySelectorAll('input[required]');

        form.querySelector('input[type="submit"]').addEventListener('click', () => {
            requiredFields.forEach((field) => {
                ParticipantRegistration.handleFieldValidation(field);
            });
        });

        requiredFields.forEach((field) => {
            field.addEventListener('keyup', () => {
                ParticipantRegistration.handleFieldValidation(field);
            });
        });
    }

    static handleFieldValidation(field) {
        field.parentNode.classList.remove('error');
        if (!field.value) {
            field.parentNode.classList.add('error');
        }
    }
}

export default ParticipantRegistration;
